var map = {
	"./Conferencegallery1.jpeg": 6006,
	"./Conferencegallery2.jpeg": 8483,
	"./Conferencegallery3.jpeg": 4396,
	"./Conferencegallery4.jpeg": 393,
	"./Conferencegallery5.jpeg": 5010,
	"./Conferencegallery6.jpeg": 5599,
	"./gallary": 8138,
	"./gallary.jsx": 8138,
	"./gallery.css": 7703,
	"./sepgallery.jpg": 1322,
	"./sepgallery10.jpg": 1449,
	"./sepgallery11.jpg": 6076,
	"./sepgallery6.jpg": 8398,
	"./sepgallery7.jpg": 9883,
	"./sepgallery8.jpg": 1536,
	"./sepgallery9.jpg": 2669,
	"./sepgallerygrid.jpg": 9942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6458;